import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export interface IFetchFactorInfluenceInfoItemArgs {
    id: string | number;
}

export const fetchFactorInfluenceInfoItem = async ({id}: IFetchFactorInfluenceInfoItemArgs) => (
    performRequest({
        url: `integration.module/ais3.factor.influence.info/${id}`,
        method: ERequestType.GET,
    })
);

